import { render, staticRenderFns } from "./vsm_mobile_filter_chips.vue?vue&type=template&id=277a2635&"
import script from "./vsm_mobile_filter_chips.vue?vue&type=script&lang=js&"
export * from "./vsm_mobile_filter_chips.vue?vue&type=script&lang=js&"
import style0 from "./vsm_mobile_filter_chips.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports